<template>
    <div class="card-content">
        <div v-for="(row, index) in groupedTypes" v-bind:key="'types-row-' + index" class="row row-compress p-b-4">
            <div v-for="type in row" v-bind:key="type.type" class="column" v-bind:class="columnWidthClass">
                <a
                    class="card card-mini block p-4"
                    v-bind:class="{'card-item-active': activeType === type.type}"
                    v-on:click="selectType(type.type)"
                >
                    <div class="card-item card-link">
                        <div class="card-figure m-t-2 i-size-large" v-html="type.icon"></div>
                        <div class="card-content p-t-2 p-b-2 text-center">
                            <div class="card-subtitle f-w-medium c-primary">{{ type.name }}</div>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <input type="hidden" v-bind:name="name" v-model="activeType" />

        <div class="row row-compress p-t-3 p-b-3 p-l-2 p-r-2 m-t-2 m-l-4 m-r-4 c-lightest-bg">
            <div class="column">
                <h4 class="add-product-heading f-s-5 m-b-2">{{ selected.name }}</h4>
                <div class="card-content">
                    <p class="f-s-4 c-primary" v-html="selected.description"></p>

                    <h4 class="f-w-bold f-s-4">{{ trans('Features Included:') }}</h4>

                    <div class="row row-collapse">
                        <div v-for="(row, rowIndex) in groupedFeatures" v-bind:key="'feature-row-' + rowIndex" class="column">
                            <div v-for="(feature, featureIndex) in row" v-bind:key="'feature-bullet-' + featureIndex" class="bullet m-b-3 p-l-5">
                                <span class="i-container i-filled-theme i-container-r-1 bullet-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="injected-svg icon inject-svg i-size-small"><path d="M9.6 14l-3.2-3.2L4 13.2l5.6 5.6L20 8.4 17.6 6z" class="icon" fill-rule="evenodd"></path></svg>
                                </span>
                                {{ feature.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        productTypes: {
            type: Array,
            required: true,
        },
        selectedType: {
            type: [String, Number],
            default: null,
        },
        itemsPerRow: {
            type: Number,
            default: 2,
        },
        name: {
            type: String,
            default: 'product_type',
        },
    },
    computed: {
        columnWidthClass() {
            let colWidth = 12 / this.itemsPerRow;
            return 'small-' + colWidth;
        },
        selected() {
            return this.productTypes.find(type => type.type === this.activeType);
        },
        groupedFeatures() {
            if (!this.selected || !this.selected.features) {
                return [];
            }

            let features = this.selected.features;
            let featuresPerColumn = Math.ceil(features.length / 2);
            let grouped = [];

            for (let i = 0; i < features.length; i += featuresPerColumn) {
                grouped.push(features.slice(i, i + featuresPerColumn));
            }

            return grouped;
        },
    },
    watch: {
        selectedType() {
            this.activeType = this.selectedType;
        },
    },
    data() {
        return {
            activeType: this.selectedType,
            groupedTypes: this.splitIntoRows(this.productTypes, this.itemsPerRow),
        }
    },
    methods: {
        splitIntoRows(items, itemsPerRow) {
            let rows = [];

            for (let i = 0; i < items.length; i += itemsPerRow) {
                rows.push(items.slice(i, i + itemsPerRow));
            }

            return rows;
        },
        selectType(typeId) {
            this.activeType = typeId;
            this.$emit('selected', typeId);
        },
    },
}
</script>